import {
  getBlob,
  getDownloadURL,
  getStorage,
  ref,
  uploadBytes,
  UploadMetadata
} from 'firebase/storage';
const storage = getStorage();

async function upload(file: File | Blob, path: string, type?: string) {
  const reference = ref(storage, path);
  const metaData: UploadMetadata = { contentType: type || file.type };

  await uploadBytes(reference, file, metaData);
  return getDownloadURL(reference);
}

export function getBlobFromUrl(url: string) {
  const reference = ref(storage, url);
  return getBlob(reference);
}

export function getAvatarFromUid(uid: string) {
  const reference = ref(storage, uid);
  return getDownloadURL(reference);
}

export async function uploadUserAvatarAsync(avatar: File, uid?: string) {
  if (!uid) return;
  return upload(avatar, uid);
}

export async function uploadUserCardMemberAsync(avatar: Blob, uid?: string) {
  if (!uid) return;
  return upload(avatar, `card_member_${uid}.png`, 'image/png');
}

export async function uploadImage(file: File) {
  return upload(file, new Date().getTime().toString());
}

export async function uploadKhassida(file: File) {
  return upload(file, new Date().getTime().toString() + file.name);
}
